import styled,{keyframes, css} from 'styled-components';

type TypeCard = {
    width?:number;
    height?:number;
    showAsGrid?:boolean;
}

const refreshAnimation = (w:number | string)=>{
    const px = `${w}px`;
    const refresh = keyframes`
        0% {
        background-position: 0px;
        }
        
        100% {
        background-position: ${px}; 
        }
    `
    return refresh;
}


export const Skeleton = styled.div<TypeCard>`
    width:${props=>props.width?`${props.width}px`:'100px'};
    height:${props=>props.height?`${props.height}px`:'100px'};
    background-color:blue;
    border-radius: 6px;
    background-size: 400px 400px;
    background: linear-gradient(
        90deg, #ededed, #ffffff, #ededed
    );
    animation:${props=>{
        let px = props.width?props.width:100; 
        return refreshAnimation(px)
    }} 2s infinite ease-out;

    ${props => props.showAsGrid ? css`
        flex-grow: 1; 
        width: 20%; 
        height: 15vw; 
        margin: 1vh 1vw;
        @media (max-width: ${props.theme.breakpoints.md}) {
            width: 45%; 
            height: 45vw; 
        }
    `  : ''}
    
`

export const CardSkeletonContainer = styled.div`
    display:flex;
    justify-content: space-around;
    flex-wrap: wrap;
`

